import {ButtonItem} from "./button-item";
import EmitEvent, {SVG_DOCUMENT, SVG_ELEMENT} from "../../../libs/emit-event";

export class Buttons {
    constructor() {
        this.bindEvent();
    }

    init() {
        document.querySelectorAll('.js-estButton:not(.is-handler)').forEach(item => new ButtonItem({el: item}));
    }

    bindEvent() {
        EmitEvent.on(SVG_DOCUMENT, this.init.bind(this));
        EmitEvent.on(SVG_ELEMENT, this.init.bind(this));
    }
}